import { withInstall } from '@xzx-design/utils'
import _Panel from './src/panel.vue'

export const Panel = withInstall(_Panel)
export default Panel

export * from './src/panel'
